<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'

import { useTableTutorSlotLog } from '../../model/shift-control/table-tutor-slot-log.hook'

defineOptions({
  name: 'TableTutorSlotLog',
})

const {
  logs,
  isLoading,
  hasLogs,
  meta,
  formatDateTime,
  formatAction,
  formatChange,
  formatActorLabel,
  getBookingId,
  setChangePage,
  setChangePerPage,
} = useTableTutorSlotLog()
</script>

<template>
  <div class="table-tutor-slot-log">
    <AppTable
      class="rounded-table"
      :meta="meta"
      :loading="isLoading"
      @change:page="setChangePage"
      @change:per-page="setChangePerPage"
    >
      <template #head>
        <AppTr>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              #
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Date and time
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Action
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Context
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              User
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Booking #
            </AppText>
          </AppTh>
        </AppTr>
      </template>

      <template
        v-if="hasLogs"
        #body
      >
        <template
          v-for="log in logs"
          :key="log.id"
        >
          <AppTr>
            <AppTd class="medium">
              <AppText
                name="body1"
                color="slate-900"
              >
                {{ log.id }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText
                name="body1"
                color="slate-900"
              >
                {{ formatDateTime(log.created_at) }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText
                name="body1"
                color="slate-900"
              >
                {{ formatAction(log) }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText
                name="body1"
                color="slate-900"
              >
                {{ formatChange(log) }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText
                name="body1"
                color="slate-900"
              >
                {{ formatActorLabel(log) }}
              </AppText>
            </AppTd>
            <AppTd class="medium">
              <AppText
                name="body1"
                color="slate-900"
              >
                <a
                  v-if="log.booking_link"
                  :href="log.booking_link"
                  class="table-tutor-slot-log__booking-link"
                >
                  #{{ getBookingId(log) }}
                </a>
                <span v-else>—</span>
              </AppText>
            </AppTd>
          </AppTr>
        </template>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./TableTutorSlotLog.scss" />
